import publicPath from './public-path';
import ShellBootstrap from './shell-bootstrap';
export default { publicPath, ShellBootstrap };
